import { useGuide } from '@/context/AuthContext';
import { SPONSOR } from '@/constants/sponsor';
import { Zap } from 'lucide-react';

/**
 * GuideAvatar - reusable mascot avatar for the user's chosen guide (Corey or Christine).
 * Sizes: sm (48px), md (72px), lg (120px), xl (200px)
 * showBadge: shows Contact Electric badge overlay
 * guide: optional override — if omitted, uses the current user's chosen guide.
 */
export default function CoreyAvatar({ size = 'md', showBadge = true, className = '', guide }) {
  const currentGuide = useGuide();
  const g = guide || currentGuide;
  const dims = { sm: 48, md: 72, lg: 120, xl: 200 };
  const px = dims[size] || 72;
  return (
    <div
      data-testid="corey-avatar"
      className={`relative inline-block shrink-0 ${className}`}
      style={{ width: px, height: px }}
    >
      <div
        className="w-full h-full overflow-hidden border-2 border-amber-500/60"
        style={{ borderRadius: '50%' }}
      >
        <img
          src={g.imageUrl}
          alt={`${g.name} - ${g.title}`}
          className="w-full h-full object-cover"
          style={{ objectPosition: 'center 15%' }}
        />
      </div>
      {showBadge && size !== 'sm' && (
        <div
          className="absolute -bottom-1 -right-1 bg-amber-400 text-zinc-950 flex items-center justify-center border-2 border-zinc-950 shadow-lg"
          style={{
            width: Math.max(20, px * 0.28),
            height: Math.max(20, px * 0.28),
            borderRadius: '50%',
          }}
          title={`Sponsored by ${SPONSOR.name}`}
        >
          <Zap size={Math.max(10, px * 0.16)} strokeWidth={2.5} />
        </div>
      )}
    </div>
  );
}
